import { Injectable, inject } from '@angular/core';
import { IFreightBasicForCarrier, IFreightBasicForShipper, UUID } from '@okcargo-apps/shared-domain';
import { BaseQueryRepository } from '../query-repository/query.repository';
import {
  GenerateAndDownloadDigitalControlDocQuery,
  GenerateAndDownloadEcmrQuery,
  GenerateAndDownloadLoadingOrderQuery,
  GenericDownloadDocumentQuery,
} from '@okcargo/query-processor';

@Injectable({
  providedIn: 'root',
})
export class DocumentQueryService {
  private readonly queryRepository = inject(BaseQueryRepository);

  public getGenericDownloadUrl(documentId: UUID): string {
    const query: GenericDownloadDocumentQuery = {
      documentId: documentId,
    };

    return this.queryRepository.buildUrl('GenericDownloadDocumentQuery', query);
  }

  public getLoadingOrderUrl(freight: IFreightBasicForCarrier | IFreightBasicForShipper, viewPrices: boolean): string {
    const query = {
      freightId: freight.id,
      driver: !viewPrices, // If 'false' the loading order contains price
    } as unknown as GenerateAndDownloadLoadingOrderQuery;

    return this.queryRepository.buildUrl('GenerateAndDownloadLoadingOrderQuery', query);
  }

  public getECmrUrl(freight: IFreightBasicForCarrier | IFreightBasicForShipper): string {
    const query: GenerateAndDownloadEcmrQuery = {
      freightId: freight.id,
    };

    return this.queryRepository.buildUrl('GenerateAndDownloadEcmrQuery', query);
  }

  public getDigitalControlDocUrl(freight: IFreightBasicForCarrier): string {
    // TODO review and fix?
    if (!freight.dcdId) {
      return '';
    }

    const query: GenerateAndDownloadDigitalControlDocQuery = {
      id: freight.dcdId,
    };

    return this.queryRepository.buildUrl('GenerateAndDownloadDigitalControlDocQuery', query);
  }
}
